import useTracker from '@/hooks/useTracker';
import { EXPAND_ORDER_DETAIL, OPEN_MF_STATUS } from './constants';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventExpandOrderDetail = (orderDetail, source = '') => {
    trackEvent(EXPAND_ORDER_DETAIL, {
      instrument: 'MF',
      bottompanel_tab_header_2: source,
      total: orderDetail?.amount,
      fund_name: orderDetail?.mf_name,
      fund_manager: '-',
      status: orderDetail?.status_transaction,
    });
  };

  const eventOpenMFStatus = (orderDetail) => {
    trackEvent(OPEN_MF_STATUS, {
      instrument: 'MF',
      bottompanel_tab_header_2: 'Order',
      total: orderDetail?.amount,
      fund_name: orderDetail?.mf_name,
      fund_manager: '-',
      status: orderDetail?.status_transaction,
    });
  };

  return {
    eventExpandOrderDetail,
    eventOpenMFStatus,
  };
};

export default useEventTracker;
